import { getKey, callOpenAICompat } from './shared';
import { t } from '../modules/i18n';

export async function callMistral(model, prompt, signal, opts) {
  const key = getKey("mistral");
  if (!key) throw new Error(t("err.nokey", { provider: "Mistral" }));
  return callOpenAICompat("Mistral", "https://api.mistral.ai/v1/chat/completions", key, model, prompt, signal, opts);
}
